import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import Loader from '../../components/Loader';
import { viewOffer, acceptOffer, declineOffer } from '../../services/truststartService';
import OfferView from './Offer.view';

const pollingDelay = 3 * 1000;
const timeoutInMs = 30 * 1000;

const delay = (delayInMs) => new Promise((resolve) => { setTimeout(() => resolve(), delayInMs); });

const pollForOffer = async (ref, requestId, expireAt) => {
  if (expireAt < Date.now()) {
    return { errorType: 'NotFound', errorMessage: 'Timeout while looking for offer' };
  }
  const response = await viewOffer(ref, requestId);
  if (response.errorType === 'NotFound') {
    await delay(pollingDelay);
    return pollForOffer(ref, requestId, expireAt);
  }
  return response;
};

export default function Offer(props) {
  const { ref, requestId } = queryString.parse(props.location.search);

  const [offer, setOffer] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const result = await pollForOffer(ref, requestId, Date.now() + timeoutInMs);
      setOffer(result);
    }
    fetchData();
  }, [ref, requestId]);

  if (!offer) {
    return (<Loader />);
  }

  const handleClick = (handler) => async () => {
    const result = await handler(ref, requestId);
    setOffer(result);
  };

  return (
    <OfferView
      requestId={requestId}
      offer={offer}
      onAccept={handleClick(acceptOffer)}
      onDecline={handleClick(declineOffer)}
    />
  );
}
